import axios from 'axios';

require('dotenv/config');

const authorizationHeaders = () => {
  const token = localStorage.getItem('vue-token');

  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Each module owns its Elasticsearch indexes and exposes `POST .../reindexing` endpoints that rebuild them from the database.
 * A module can have several indexes (e.g. treatments, analyses and certificates): one endpoint per index.
 */
export const reindexModules = () => [
  {
    key: 'contacts',
    endpoints: [ `${process.env.VUE_APP_CONTACTS_BACKEND_URL}/contacts/reindexing` ]
  },
  {
    key: 'offers',
    endpoints: [ `${process.env.VUE_APP_OFFERS_BACKEND_URL}/offers/reindexing` ]
  },
  {
    key: 'transports',
    endpoints: [ `${process.env.VUE_APP_TRANSPORTS_BACKEND_URL}/transports/reindexing` ]
  },
  {
    key: 'treatments',
    endpoints: [
      `${process.env.VUE_APP_TREATMENTS_BACKEND_URL}/treatments/reindexing`,
      `${process.env.VUE_APP_TREATMENTS_BACKEND_URL}/analyses/reindexing`,
      `${process.env.VUE_APP_TREATMENTS_BACKEND_URL}/certificates/reindexing`
    ]
  },
  {
    key: 'preInvoices',
    endpoints: [ `${process.env.VUE_APP_PREINVOICE_BACKEND_URL}/invoices/reindexing` ]
  },
  {
    key: 'invoices',
    endpoints: [ `${process.env.VUE_APP_INVOICE_BACKEND_URL}/invoices/reindexing` ]
  },
  {
    key: 'exits',
    endpoints: [
      `${process.env.VUE_APP_EXITPROCESS_BACKEND_URL}/exits/reindexing`,
      `${process.env.VUE_APP_EXITPROCESS_BACKEND_URL}/flows/reindexing`
    ]
  }
];

/** Reindexes one module, one index after the other. Rejects with the first error. */
export const reindexModule = module => module.endpoints.reduce(
  (previous, endpoint) => previous.then(() => axios.post(endpoint, {}, { headers: authorizationHeaders() })),
  Promise.resolve()
);
